import {
  FaInstagram,
  FaLinkedin,
  FaYoutube,
} from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";

/**
 * The Institute's own social presence. Single source for every surface that
 * links out to it — the GWBI hub card, the landing footer, Contact and About.
 * Add or change a handle here and all of them follow.
 */
const SOCIAL_LINKS = [
  {
    name: "LinkedIn",
    icon: FaLinkedin,
    url: "https://www.linkedin.com/company/global-wine-business-institute/",
  },
  {
    name: "Instagram",
    icon: FaInstagram,
    url: "https://www.instagram.com/globalwinebusinessinstitute/",
  },
  {
    name: "YouTube",
    icon: FaYoutube,
    url: "https://www.youtube.com/channel/UCakZsnNIyEQJIgTwhBULTEQ",
  },
  {
    name: "X",
    icon: FaXTwitter,
    url: "https://x.com/global_wine_bi",
  },
];

export default SOCIAL_LINKS;
